import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const AddProductModal = ({ open, onClose, onSave }) => {
  const [formValues, setFormValues] = useState({
    id: "",
    name: "",
    price: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = () => {
    if (!formValues.id || !formValues.name || !formValues.price) {
      alert("Please fill in the product ID, name, and price!");
      return;
    }

    // Call the `onSave` function passed from the parent component
    onSave({
      id: formValues.id,
      title: { translations: { en_us: formValues.name } },
      price_info: { price: Number(formValues.price) },
      description: { translations: { en_us: formValues.description } },
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" gutterBottom>
          Add New Product
        </Typography>
        <TextField
          label="Product ID (Manual Entry)"
          name="id"
          fullWidth
          margin="normal"
          value={formValues.id}
          onChange={handleChange}
        />
        <TextField
          label="Product Name"
          name="name"
          fullWidth
          margin="normal"
          value={formValues.name}
          onChange={handleChange}
        />
        <TextField
          label="Price"
          name="price"
          type="number"
          fullWidth
          margin="normal"
          value={formValues.price}
          onChange={handleChange}
        />
        <TextField
          label="Description"
          name="description"
          fullWidth
          margin="normal"
          value={formValues.description}
          onChange={handleChange}
        />
        <Box mt={2} display="flex" justifyContent="space-between">
          <Button onClick={onClose} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Add Product
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddProductModal;
